export default __webpack_public_path__ + "static/media/6568E7DD-5806-4F29-B8C1-0EB38C2EBDFA.e63e0f52.jpg";